<template>
    <div id="app">
        <headerPage></headerPage>
        <router-view />
        <footerPage></footerPage>
    </div>
</template>

<script>
import headerPage from '@/components/headerPage.vue'
import footerPage from '@/components/footerPage.vue'

export default {
    name: 'App',
    components: {
        headerPage,
        footerPage,
    },
}
</script>

<style lang="less">
@import '~@/assets/js/swiper-bundle.min.css';
.m_width {
    width: 1400px;
    margin: 0 auto;
}

.btnHover {
    cursor: pointer;

    &:hover {
        opacity: 0.85;
    }
}

.btnHover2 {
    vertical-align: bottom;
    cursor: pointer;
}

.btnHover2:not(:disabled):hover {
    opacity: 1;
    position: relative;
    overflow: hidden;

    &::before {
        animation: ani_ripple 0.75s;
        z-index: 1;
        content: '';
        position: absolute;
        display: block;
        transition: all 0.6s;
        width: 100%;
        height: 0;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        padding-top: 100%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes ani_ripple {
    0% {
        background: rgba(0, 0, 0, 0.25);
        transform: translateX(-50%) translateY(-50%) scale(0);
    }

    to {
        background: transparent;
        transform: translateX(-50%) translateY(-50%) scale(1);
    }
}
</style>
